<!--
 * @Author: baike
 * @LastEditors: baike
-->
<template>
  <div>
    <div class="container">
      <Label title="项目基本信息"></Label>
      <div class="con_box">
        <div v-for="item in list" :key="item.key_a" class="li_box">
          <div class="flex_1">
            <div class="name">{{ item.name_a }}：</div>
            <div class="value">{{ projectInfo[item.key_a] }}</div>
          </div>
          <div class="flex_1">
            <div class="name">{{ item.name_b }}：</div>
            <div class="value">{{ projectInfo[item.key_b] }}</div>
          </div>
          <div class="flex_1">
            <div class="name">{{ item.name_c }}：</div>
            <div class="value">{{ projectInfo[item.key_c] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["projectInfo"],
  components: {},
  data() {
    return {
      list: [
        {
          name_a: "项目编号",
          key_a: "projectCode",
          name_b: "项目名称",
          key_b: "projectName",
          name_c: "客户名称",
          key_c: "customerName",
        },
        {
          name_a: "产品名称",
          key_a: "productName",
          name_b: "担保金额(万元)",
          key_b: "guaranteeAmount",
          name_c: "担保期限(月)",
          key_c: "guaranteePeriod",
        },
        {
          name_a: "合作机构",
          key_a: "bankName",
          name_b: "经办人",
          key_b: "handlerName",
          name_c: "受理日期",
          key_c: "createTime",
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang='scss' scoped>
.head_label {
  margin: 30px 0 30px 0;
}
.container {
  .con_box {
    margin-top: 40px;
    padding-left: 40px;
    .li_box {
      display: flex;
      .flex_1 {
        flex: 1;
        text-align: left;
        font-family: "Arial Normal", "Arial", sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        letter-spacing: normal;
        color: #666;
        margin-bottom: 15px;
        display: flex;
        line-height: 20px;
        .name {
          width: 115px;
        }
        .value {
          width: 300px;
          white-space: normal;
          color: #333;
          word-break: break-all;
          word-wrap: break-word;
        }
      }
    }
  }
}
</style>